
export const areaChartData = [
  {
    name: 'Page A',
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: 'Page B',
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
      name: 'Page C',
      uv: 1890,
      pv: 4800,
      amt: 2181,
  },
  {
    name: 'Page D',
    uv: 3600,
    pv: 9800,
    amt: 3090,
  },
  {
    name: 'Page E',
    uv: 3780,
    pv: 3908,
    amt: 2000,
  }
];

export const pieChartData = [
  { name: 'Group A', value: 400 },
  { name: 'Group B', value: 300 },
  { name: 'Group C', value: 300 },
  { name: 'Group D', value: 200 },
];

export const barChartData = [
  {
    name: 'Lead A',
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: 'Lead B',
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: 'Lead C',
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: 'Lead D',
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: 'Lead E',
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: 'Lead F',
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: 'Lead G',
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
];
